import type { MRT_ColumnDef } from "mantine-react-table-open";
import { LAST_YEAR } from "../../../../utils/dates";
import type {
  DataAssessment,
  SiteOverviewSite,
  SiteStatusSite
} from "../../site-status-types";
import { getDataSufficientBaseColumn } from "./getDataSufficientBaseColumn";

function getSubMeterDataIsSufficientColumn(): MRT_ColumnDef<
  SiteOverviewSite | SiteStatusSite
> {
  return {
    header: `Daten der Erzeugungsanlagen ${LAST_YEAR}`,
    accessorFn: (rowData) =>
      getSiteDataAssessmentGeneratorSubMeter(rowData.siteDataAssessment),
    ...getDataSufficientBaseColumn()
  };
}

function getSiteDataAssessmentGeneratorSubMeter(
  siteDataAssessment?: DataAssessment
): boolean | null {
  if (!siteDataAssessment) {
    return null;
  }

  if (siteDataAssessment.generatorsSufficient !== null) {
    return siteDataAssessment.generatorsSufficient;
  } else if (siteDataAssessment.subMeterDataIsSufficient !== null) {
    return siteDataAssessment.subMeterDataIsSufficient;
  }

  return null;
}

export { getSubMeterDataIsSufficientColumn };
